<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    placeholder="请选择商家"
    :clearable="clearable"
    idKey="RecordId"
    labelKey="BusiName"
    :get-data-func="getDataFunc"
    :disabled="disabled"
  />
</template>
<script>
import api from "@/api/shop/business";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkState:{
      type:Number,
      default:2,
    }
  },
  components: { commonSelect },
  data() {
    return { api };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        console.log(this.checkState);
        this.api.list({ Status: 1,CheckState:this.checkState }).then((res) => {
          // console.log(res.Data);
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

